import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from "@material-ui/core/styles";



export interface FieldsetProps{
    legend?: string;
}

type PropsType = FieldsetProps & WithStyles<typeof styles>;

class Fieldset extends React.PureComponent<PropsType> {

    render() {
        const {legend, children, classes} = this.props;
        const legendElement = legend
            ? <legend className={classes.legend}>{legend}</legend>
            : null;
        return <fieldset className={classes.root}>
                {legendElement}
                {children}
            </fieldset>;
        }
}


const styles = (theme:Theme) => createStyles({
    root: {
        border: 'none',
        padding:0,
        margin:0,
        marginBottom: 3 * theme.spacing.unit,
    },

    legend: {
       padding:0,
       width: '100%',
        marginBottom: 2 * theme.spacing.unit,
        fontSize: 18,
    }
});


export default withStyles(styles)(Fieldset);
